<template>
  <div class="input-number" :style="{height: `${height}px`, width: `${width}px`}">
    <el-button
      class="input-number__minus"
      icon="el-icon-minus"
      size="mini"
      :class="{active: active}"
      :style="{width: `${width/3}px`}"
      @click="updateValue(false)"
      :disabled="value <= min">
    </el-button>
    <div class="input-number__label"
         :class="{active: active}"
         :style="{width: '50px', width: `${width/3}px`}">
      {{ value }}
    </div>
    <el-button
      class="input-number__plus"
      :class="{active: active}"
      icon="el-icon-plus"
      size="mini"
      :style="{width: `${width/3}px`}"
      @click="updateValue(true)"
      :disabled="value >= max">
    </el-button>
  </div>
</template>

<script>
export default {
  name: 'inputNumber',
  props: {
    step: {
      type: Number,
      default: 1,
    },
    value: {
      type: Number,
      required: true,
    },
    min: {
      type: Number,
      default: -Infinity,
    },
    max: {
      type: Number,
      default: Infinity,
    },
    height: {
      type: Number,
      default: 26,
    },
    width: {
      type: Number,
      default: 80,
    },
    active: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    updateValue(isAddition) {
      if (isAddition) {
        const value = this.value + this.step;
        this.$emit('change', value >= this.max ? this.max : value);
      } else {
        const value = this.value - this.step;
        this.$emit('change', value <= this.min ? this.min : value);
      }
    },
  },
};
</script>

<style scoped lang="scss">
  .active{
    background-color: rgba(28, 219, 161, 0.1);
    border-color: $--color-primary;
  }
.input-number {
  display: grid;
  height: 26px;
  width: 80px;
  grid-template-columns: 33% 33% 33%;
  color: $--color-secondary;
  &__minus {
    color: $--color-secondary;
    font-size: $--font-size-tiny;
    box-shadow: none;
    padding: 3px;
    border-radius: $--border-radius-base 0 0 $--border-radius-base;
    border: 1px solid $--color-secondary;
    width: 26px;
  }
  &__label {
    display: grid;
    place-content: center;
    align-items: center;
    font-size: $--font-size-tiny;
    text-align: center;
    padding: 0 10px;
    border-top: 1px  solid $--color-secondary;
    border-bottom: 1px  solid $--color-secondary;
  }
  &__plus {
    color: $--color-secondary;
    font-size: $--font-size-tiny;
    padding: 3px;
    width: 26px;
    box-shadow: none;
    border-radius:  0  7px 7px 0;
    border: 1px solid $--color-secondary;
  }
}
</style>
